import { render, staticRenderFns } from "./notice_of_negotiations.vue?vue&type=template&id=4ef56064&scoped=true"
import script from "./notice_of_negotiations.vue?vue&type=script&lang=js"
export * from "./notice_of_negotiations.vue?vue&type=script&lang=js"
import style0 from "./notice_of_negotiations.vue?vue&type=style&index=0&id=4ef56064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef56064",
  null
  
)

export default component.exports